import { c as _c } from "react/compiler-runtime";
import ItemContent from 'modules/stores/store/components/item-content';
import ItemWrapper from 'modules/stores/store/components/item-wrapper';
import { useLinkActions } from 'modules/stores/store/content/link/hooks/use-link-actions';
import { LinkItemViewType } from 'modules/stores/store/content/link/types/link-interface';
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item';
import { useChangeItemDraft } from '../../hooks/use-change-item-draft';
import { getComplexItemUpdateData } from '../../utils/get-complex-item-update-data';
const LinkContent = linkView => {
  const $ = _c(25);
  const {
    deleteLink,
    updateLink
  } = useLinkActions();
  const {
    onDelete
  } = useDeleteItem();
  let t0;
  if ($[0] !== deleteLink || $[1] !== linkView.id || $[2] !== linkView.itemId || $[3] !== onDelete) {
    t0 = () => onDelete({
      deleteCallback: () => deleteLink(linkView.id),
      itemId: linkView.itemId
    });
    $[0] = deleteLink;
    $[1] = linkView.id;
    $[2] = linkView.itemId;
    $[3] = onDelete;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const onDeleteLink = t0;
  const {
    onChangeItemDraft
  } = useChangeItemDraft();
  let t1;
  if ($[5] !== linkView || $[6] !== onChangeItemDraft || $[7] !== updateLink) {
    t1 = () => onChangeItemDraft({
      callback: async () => {
        await updateLink(linkView.id, getComplexItemUpdateData({
          ...linkView,
          draft: true
        }));
      },
      itemId: linkView.itemId,
      draft: true
    });
    $[5] = linkView;
    $[6] = onChangeItemDraft;
    $[7] = updateLink;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const onSaveDraft = t1;
  let t2;
  if ($[9] !== linkView || $[10] !== onChangeItemDraft || $[11] !== updateLink) {
    t2 = () => onChangeItemDraft({
      callback: async () => {
        await updateLink(linkView.id, getComplexItemUpdateData({
          ...linkView,
          draft: false
        }));
      },
      itemId: linkView.itemId,
      draft: false
    });
    $[9] = linkView;
    $[10] = onChangeItemDraft;
    $[11] = updateLink;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const onPublish = t2;
  let t3;
  if ($[13] !== linkView.draft || $[14] !== linkView.itemId || $[15] !== linkView.thumbnail || $[16] !== linkView.title || $[17] !== linkView.type || $[18] !== onDeleteLink || $[19] !== onPublish || $[20] !== onSaveDraft) {
    t3 = <ItemContent draft={linkView.draft} onDelete={onDeleteLink} onSaveDraft={onSaveDraft} onPublish={onPublish} itemId={linkView.itemId} title={linkView.title} itemType={linkView.type} thumbnail={linkView.thumbnail} />;
    $[13] = linkView.draft;
    $[14] = linkView.itemId;
    $[15] = linkView.thumbnail;
    $[16] = linkView.title;
    $[17] = linkView.type;
    $[18] = onDeleteLink;
    $[19] = onPublish;
    $[20] = onSaveDraft;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== linkView.itemId || $[23] !== t3) {
    t4 = <ItemWrapper id={linkView.itemId}>{t3}</ItemWrapper>;
    $[22] = linkView.itemId;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
};
export default LinkContent;